import { Link } from 'react-router-dom';
import { MdLocationOn, MdEdit } from 'react-icons/md';
import { FaTrash } from 'react-icons/fa';
import moment from 'moment';

const FALLBACK_IMAGE =
  'https://images.unsplash.com/photo-1560184897-ae75f418493e?auto=format&fit=crop&w=800&q=80';

export default function PropertyItem({ listing, id, onEdit, onDelete }) {
  // Safely determine image URL
  const hasImages =
    listing &&
    Array.isArray(listing.imgUrls) &&
    listing.imgUrls.length > 0;

  const imageUrl = hasImages ? listing.imgUrls[0] : FALLBACK_IMAGE;

  return (
    <li className="relative bg-white flex flex-col justify-between items-center shadow-md hover:shadow-xl rounded-md overflow-hidden transition-shadow duration-200 m-[10px]">
      <Link to={`/category/${listing.type}/${id}`} className="contents">
        <img
          src={imageUrl}
          alt={listing.name}
          className="h-[170px] w-full object-cover hover:scale-105 transition-scale duration-200 ease-in"
        />

        <div className="w-full p-[10px]">
          <div className="flex items-center space-x-1">
            <MdLocationOn className="h-4 w-4 text-green-600" />
            <p className="font-semibold text-sm mb-[2px] text-gray-600 truncate">
              {listing.address}
            </p>
          </div>

          <p className="font-semibold m-0 text-xl truncate">
            {listing.name}
          </p>

          <p className="text-[#457b9d] mt-2 font-semibold">
            ₹
            {(
              listing.offer ? listing.discountedPrice : listing.regularPrice
            )
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            {listing.type === 'rent' && ' / month'}
          </p>

          <div className="flex items-center mt-[10px] space-x-3">
            <p className="font-bold text-xs">
              {listing.bedrooms > 1
                ? `${listing.bedrooms} Beds`
                : '1 Bed'}
            </p>
            <p className="font-bold text-xs">
              {listing.bathrooms > 1
                ? `${listing.bathrooms} Baths`
                : '1 Bath'}
            </p>
          </div>

          <p className="text-xs text-gray-500 mt-2">
            {moment(listing.timestamp?.toDate?.() || listing.timestamp).fromNow()}
          </p>
        </div>
      </Link>

      <div className="absolute bottom-2 right-2 flex space-x-2">
        {onEdit && (
          <MdEdit
            className="text-blue-500 cursor-pointer"
            onClick={() => onEdit(id)}
          />
        )}
        {onDelete && (
          <FaTrash
            className="text-red-500 cursor-pointer"
            onClick={() => onDelete(id)}
          />
        )}
      </div>
    </li>
  );
}
